module.exports = __webpack_public_path__ + "img/chat-btn.086ffcfa.svg";